// TODO Add functions from DragNDrop in process function

// Reads the content of a file and updates progress
const handleReadFile = (file: File): Promise<ArrayBuffer> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    // Event that is triggered during the file read operation to report progress
    fileReader.onprogress = (event: ProgressEvent<FileReader>) => {
      if (event.lengthComputable) {
        // Calculate the percentage of the file that's been read
        // const percentLoaded = Math.round((event.loaded / event.total) * 100);
        // //console.log('percentLoaded', percentLoaded);
        // Update progress for this file in the render files array
      }
    };

    // Event triggered when the file reading operation completes
    fileReader.onloadend = () => {
      if (fileReader.result) {
        const readFileData = fileReader.result as ArrayBuffer;
        resolve(readFileData); // Resolve with the file data
      } else {
        reject(new Error('File could not be read'));
      }
    };

    fileReader.onerror = () => reject(new Error('Error reading file'));
    fileReader.readAsArrayBuffer(file);
  });
};

// Validation helper function
const validateSQLHistoryInputs = (
  hash: string,
  currentFile: File,
  jsonString: string | null,
  validationMethod: string | null,
) => {
  if (!hash) return 'Hash is required';
  if (!currentFile?.name?.trim()) return 'File name is required';
  if (!currentFile?.size || currentFile.size <= 0) return 'File size must be greater than 0';
  if (!currentFile?.lastModified || isNaN(currentFile.lastModified))
    return 'Invalid file last modified date';
  if (validationMethod && !['timestamp', 'fullfile'].includes(validationMethod))
    return 'Invalid validation method';
  if (jsonString) {
    try {
      JSON.parse(jsonString); // Validate JSON format
    } catch {
      return 'Invalid JSON string';
    }
  }
  return null; // All validations passed
};

const hashExistInFiles = (files: CustomFile[], hash: string) => {
  return files.some((file) => file.fileHash === hash);
};

const rangeStart = (index, offset) => {
  let returnValue = +offset;

  // if (returnValue < 1000) {
  return `${returnValue} B`;
  // }

  // return `${(returnValue / 1024).toFixed(1)} KB`;
};

const rangeEnd = (offset, packetSize) => {
  let returnValue = +offset + +packetSize - 1;

  // if (returnValue < 1000) {
  return `${returnValue} B`;
  // }

  // return `${(returnValue / 1024).toFixed(1)} KB`;
};

const convertToKb = (fileSize) => {
  if (fileSize < 1000) {
    return `${fileSize} Bytes`;
  }

  return `${(fileSize / 1024).toFixed(1)} KB`;
};

export {
  handleReadFile,
  validateSQLHistoryInputs,
  hashExistInFiles,
  rangeStart,
  rangeEnd,
  convertToKb,
};
